import { StoreModule } from '@ngrx/store';
import { NgModule, enableProdMode } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Router } from '@angular/router';
import { RouterStoreModule } from '@ngrx/router-store';
import { CommonModule } from '@angular/common';

import {
  ControllerConnectionService, CommonConfigService, BrokerService,
  UrlFactoryService, StorageService, CoreModule
} from '@c4/core';

import { AuthModule } from '@c4/auth';
import { UIModule } from '@c4/ui';

import { ProgrammingModule } from '@c4/programming';
import { ProgrammingRoutingModule } from '@c4/programming';
import { SysmanModule } from '@c4/sysman';

import { ComposerComponent } from './composer/composer.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { BackupProjectComponent } from './backup/backup-project.component';
import { SplashComponent } from './splash/splash.component';
import { NotImplementedComponent } from './not-implemented/not-implemented.component';
import { ErrorComponent } from './error/error.component';
import { AboutComponent } from './about/about.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { LicenseComponent } from './license/license.component';
import { TOSComponent } from './tos/tos.component';
import { OSSComponent } from './oss/oss.component';

import { AppRoutingModule } from './app-routing.module';

import { APP_PROVIDERS } from './app.providers';
import { reducer } from './app.stores';

import { AppComponent } from './app.component';

import { environment } from '../environments/environment';

if (environment.production) {
  enableProdMode();
}

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpModule,
    CoreModule,
    AuthModule,
    UIModule,
    SysmanModule,
    ProgrammingModule,
    RouterModule,
    AppRoutingModule,
    RouterStoreModule.connectRouter(),
    StoreModule.provideStore(reducer),
  ],
  declarations: [
    AppComponent,
    ComposerComponent,
    WelcomeComponent,
    SplashComponent,
    NotImplementedComponent,
    ErrorComponent,
    AboutComponent,
    NavbarComponent,
    PrivacyComponent,
    LicenseComponent,
    TOSComponent,
    OSSComponent,
    BackupProjectComponent
  ],
  providers: [
    ...APP_PROVIDERS,
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts